import Login from "./views/shared/Login.jsx";
import TrocarSenha from "./views/admin/seguranca/TrocarSenha.jsx";
import EsqueceuSenha from "./views/shared/EsqueceuSenha.jsx";

import DashBoard from "./views/admin/DashBoard.jsx";
import Home from "./views/admin/Home.jsx";

var routes = [
    {
      path: "/login",
      name: "Login",
      icon: "",
      component: Login,
      layout: "/auth",
      sidebar: false
    },
    {
      path: "/esqueceusenha",
      name: "EsqueceuSenha",
      icon: "",
      component: EsqueceuSenha,
      layout: "/auth",
      sidebar: false
    },  
    {
      path: "/home",
      name: "Home",
      icon: "fa fa-bar-chart",
      component: Home,
      layout: "/operador",
      sidebar: false
    },  
    {
      path: "/dashboard",
      name: "Dashboard",
      icon: "fa fa-bar-chart",
      component: DashBoard,
      layout: "/operador",
      sidebar: false
    },  
   
    {
      path: "/trocarsenha",
      name: "Trocar Senha",
      icon: "",
      component: TrocarSenha,
      layout: "/operador",
      sidebar: false
    },
  ];

export default routes;
